import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import UniqueEntryPage from './UniqueEntryPage';
import CreateEntryPage from './CreateEntryPage';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { useRMContext } from '../../../services/contexts/RMContext';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import ManualPunchComponent from '../shareManagement/ManualPunchComponent';


export default function CRMMainPage() {

    const { setCurrModule, allowedFunc } = useLogin()
    const { getKYCVerifiedCustomer } = useKYCContext()
    const { getAllAdmin } = useRMContext()
    const { editManualPunch, setEditManualPunch } = useBuyOrderContext();

    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['crm:get_insights']) || allowedFunc.includes(configs.functionList['crm:add_insight'])) {
                    setCurrModule(configs.modules.CRM)
                    getKYCVerifiedCustomer()
                    getAllAdmin()
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
        return () => setEditManualPunch(false)
    }, [])

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                {editManualPunch ? <ManualPunchComponent /> :
                    <div id='rmContainer' className="rm-container">
                        <UniqueEntryPage />
                        <CreateEntryPage />
                        <ToastPage />
                    </div>
                }
            </div>
        </>
    )
}